import * as React from 'react'

import { mq, spacing, styled } from '@thg-commerce/enterprise-theme'
import { WidgetRenderer } from '@thg-commerce/enterprise-widgets'

export enum WidgetDisplayLocation {
  SHOW_WIDGET_IN_PRODUCT_LIST = 'showWidgetInProductList',
  SHOW_WIDGET_AFTER_PRODUCT_LIST = 'showWidgetAfterProductList',
}

export const ProductListItem = styled.li`
  width: 100vw;
  max-width: 100vw;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
  grid-column: 1 / -1;
  display: block;
  background-color: ${(props) => props.theme.colors.palette.greys.lighter};
  margin-bottom: ${spacing(6)};
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    padding: ${spacing(2.5)};
  }
`

export const PromoListItem = styled.li`
  display: block;
  grid-column: span 2;
  margin-top: 0;
`

interface ProductWidgetItemProps {
  widgets: any[]
  widgetDisplayLocation: WidgetDisplayLocation
  index: number
}

const renderWidgets = (ws: any[]) => (
  <WidgetRenderer widgets={ws} showWidgetItem={true} />
)

export const ProductWidgetItem: React.FC<ProductWidgetItemProps> = React.memo(
  ({ widgets, widgetDisplayLocation, index }) => {
    const isValidWidgetPosition =
      widgetDisplayLocation !==
        WidgetDisplayLocation.SHOW_WIDGET_IN_PRODUCT_LIST ||
      index === 4 ||
      index === 8

    const displayableWidgets = React.useMemo(
      () =>
        isValidWidgetPosition
          ? widgets.filter((widget) => widget[widgetDisplayLocation] === true)
          : [],
      [widgets, widgetDisplayLocation, isValidWidgetPosition],
    )

    if (!isValidWidgetPosition || displayableWidgets.length === 0) return null

    if (
      widgetDisplayLocation ===
      WidgetDisplayLocation.SHOW_WIDGET_IN_PRODUCT_LIST
    ) {
      const { promoWidgets, otherWidgets } = displayableWidgets.reduce(
        (acc, widget) => {
          if (widget.__typename === 'PromoCard') {
            acc.promoWidgets.push(widget)
          } else {
            acc.otherWidgets.push(widget)
          }
          return acc
        },
        { promoWidgets: [] as any[], otherWidgets: [] as any[] },
      )

      if (index === 4 && promoWidgets.length > 0) {
        return (
          <React.Fragment>
            {promoWidgets.map((promo, i) => (
              <PromoListItem key={i}>{renderWidgets([promo])}</PromoListItem>
            ))}
          </React.Fragment>
        )
      }

      if (index === 8 && otherWidgets.length > 0) {
        return <ProductListItem>{renderWidgets(otherWidgets)}</ProductListItem>
      }

      return null
    }

    return renderWidgets(displayableWidgets)
  },
)
